$( document ).ready(function() {
  $('.psc-content-header span').on('click', function () {
    $('.psc-content-header span').removeClass('active');
    $(this).addClass('active');
    $('.psc-content-root').attr('data-type', $(this).attr('data-span-type'))
  });

  $('.psc-swith span').on('click', function () {
    let size_ = $(this).attr('data-span-size');
    $('.psc-swith span').removeClass('active');
    $(`.psc-swith span[data-span-size="${size_}"]`).addClass('active');
    $('.psc-content-root').attr('data-size', size_)
  });

  $('.psc-a-title').on('click', function () {
    if($(this).hasClass('open')) {
      $(this).removeClass('open');
      $(this).next().slideUp();
    } else {
      $('.psc-a-title').removeClass('open');
      $('.psc-a-body').slideUp();
      $(this).addClass('open');
      $(this).next().slideDown();
    }
  });

})